var map = {
	"./icon_phone_0.png": "8170",
	"./icon_phone_1.png": "065b",
	"./icon_phone_2.png": "5a90",
	"./icon_phone_3.png": "a29e",
	"./icon_phone_white.png": "9ef9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a100";